import type { PropsWithChildren, ReactNode } from 'react'
import { DropdownAvatar, InstallChromeButton } from '@/components'
import { useMiscellaneousContext } from '@/miscellaneous'
import { HamburgerIcon } from '@mote/assets/icons'
import { Block, IconButton } from '@mote/ui'
import { DashboardLayout, useDashboardContext } from '../Dashboard'
import { HeaderBase } from '../shared'

export interface XLMoteAuthenticatedLandingLayoutProps {
  headerContent?: ReactNode
}

export function AuthenticatedLandingLayout(
  props: PropsWithChildren<XLMoteAuthenticatedLandingLayoutProps>
): JSX.Element {
  return (
    <DashboardLayout
      headerOverride={
        <AuthenticatedLandingLayoutHeader headerContent={props.headerContent} />
      }
      hideFooter
      noPadding
    >
      {props.children}
    </DashboardLayout>
  )
}

function AuthenticatedLandingLayoutHeader(
  props: XLMoteAuthenticatedLandingLayoutProps
) {
  const miscellaneousContext = useMiscellaneousContext()
  const dashboardContext = useDashboardContext()

  return (
    <HeaderBase bg='grey.l4' dataTestId='landing-authenticated-nav-header'>
      {dashboardContext.getShouldSidebarCollapse() ? (
        <IconButton
          //@ts-expect-error
          onClick={dashboardContext.toggleSidebar}
          icon={<HamburgerIcon />}
          variant='ghost'
          pill={false}
        />
      ) : miscellaneousContext.isExtensionInstalled ? null : (
        <InstallChromeButton />
      )}
      <Block layout='horizontal' align='center' gap={8} margin='0 0 0 auto'>
        {props.headerContent}
        <DropdownAvatar />
      </Block>
    </HeaderBase>
  )
}
